/* The Whole Story – cart drawer variant change (snippets/twst-cart-drawer.liquid).
   Shopify can't change a line's variant in place, so: add the new variant with the line's quantity,
   remove the old line, then let Dawn's <cart-drawer> re-render itself from the returned sections. */
if (!customElements.get('twst-cart-variant')) {
  customElements.define(
    'twst-cart-variant',
    class TwstCartVariant extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        if (!this.select || this.select.dataset.bound) return;
        this.select.dataset.bound = 'true';
        this.initial = this.select.value;
        // stopPropagation: <cart-drawer-items> treats any bubbling "change" as a quantity change
        this.select.addEventListener('change', (event) => {
          event.stopPropagation();
          this.swap();
        });
      }

      async swap() {
        const drawer = this.closest('cart-drawer');
        const item = this.closest('.cart-item');
        const newId = Number(this.select.value);
        const quantity = Number(this.dataset.quantity) || 1;
        if (!drawer || String(newId) === this.initial) return;

        this.setLoading(item, true);
        this.showError('');

        try {
          const added = await fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: newId, quantity }] }),
          }).then((response) => response.json());
          if (added.status) throw new Error(added.description || added.message);

          const state = await fetch(`${routes.cart_change_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({
              id: this.dataset.lineKey,
              quantity: 0,
              sections: drawer.getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname,
            }),
          }).then((response) => response.json());
          if (state.errors) throw new Error(state.errors);

          drawer.renderContents(state);
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state, variantId: newId });
          }
        } catch (error) {
          this.select.value = this.initial;
          this.showError(error.message || window.cartStrings?.error || '');
          this.setLoading(item, false);
        }
      }

      setLoading(item, on) {
        this.select.disabled = on;
        if (!item) return;
        item.classList.toggle('is-updating', on);
        item.querySelector('.loading__spinner')?.classList.toggle('hidden', !on);
      }

      showError(message) {
        const error = document.getElementById(`CartDrawer-LineItemError-${this.dataset.index}`);
        const text = error?.querySelector('.cart-item__error-text');
        if (text) text.textContent = message;
      }
    }
  );
}
